import { ENTITY_ACTION_PERMISSIONS_QUERY } from "@app/shared-core/queries/entity-action-permissions.query";
import { CREATED_BY_QUERY } from "@app/shared/users/users/queries/created-by.query";

/** GraphQL selection for the reservation source parent form and edit page. */
export const RESERVATION_SOURCE_PARENT_FORM_QUERY = `
  id
  entityId
  name
  code
  enabled
  createdBy { ${CREATED_BY_QUERY} }
  createdAt
  updatedAt
  ${ENTITY_ACTION_PERMISSIONS_QUERY}
`;
